import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

// pattern constants
// required: all patters must begin with /^ and end with $/
export const valid_acceptable      = /^[a-zA-Z0-9-_\s\~\!\@\#\$\%\^\&\*\(\)\+\{\}\|\:\?\[\]\\\;\/\,\.]+$/;
export const valid_acceptable_name = /^([a-zA-Z0-9-\&\*\#\/\+\@]+\s?)*$/;
export const valid_acceptable_withdraw_reason      = /^[a-zA-Z0-9-_\s\~\!\@\#\$\=\'\^\&\*\(\)\+\{\}\|\:\?\[\]\\\;\/\,\.]+$/;
export const valid_account_number  = /^[0-9]*$/;
export const valid_alpha           = /^[a-z]*$/;
export const valid_alpha_dot_space = /^[a-z. ]*$/;
export const valid_middle_initial  = /^[a-zA-Z]*$/;
export const valid_city 		   = /^[A-Za-z. ]*$/;
export const valid_acceptable_name_range = /^.{0,30}$/;
export const valid_dispute_amount  = /^(-?\d+(\.\d{2})?)?$/;
export const valid_dispute_amount_characters = /^([a-zA-Z0-9\.\-]*)$/;
export const valid_at_least_5      = /^.{5,}$/;
export const valid_at_least_6      = /^.{6,}$/;
export const valid_date            = /^((0[1-9]|[1-9]|1[012])[/](0[1-9]|[1-9]|[12][0-9]|3[01])[/](19|20)\d\d)$/;
//export const valid_date            = /^(((18|19|20)\d\d)[-](0[1-9]|1[0-2])[-](0[1-9]|[1-2][0-9]|[3][0|1]))$/;
export const valid_date_picker_format    = /^(?:(Sun|Mon|Tue|Wed|Thu|Fri|Sat).*)$/;
// export const valid_email_address   = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const valid_email_address   = /^(?!.*([.])\1{1})([\w\.\-\+\{\}\=\`\|\?]+)@(?![.-])([a-zA-Z\d.-]+)\.([a-zA-Z.][a-zA-Z]{1,6})$/;
export const valid_not_more_than_17 = /^.{1,17}$/;
export const valid_not_more_than_24 = /^.{1,24}$/;
export const valid_not_more_than_25 = /^.{1,25}$/;
export const valid_not_more_than_32 = /^.{1,32}$/;
export const valid_not_more_than_64 = /^.{1,64}$/;
export const valid_not_more_than_50 = /^.{1,50}$/;
export const valid_not_more_than_144  = /^.{1,144}$/;
export const valid_not_more_than_1000 = /^.{1,1000}$/;
export const valid_numeric         = /^\d*$/;
export const valid_phone_us = /^(\(?(\d\d\d)\)?)\D?(\d\d\d)\D?(\d\d\d\d)$/;
export const valid_rlos_phone_us        = /^(((\(?(\d\d\d)\)?)\-?(\d\d\d)\-?(\d\d\d\d))?)$/;
export const valid_range_14_16     = /^.{14,16}$/;
export const valid_required        = /^.{1,}$/;
export const valid_required_name   = /^.{1,}$/;
export const valid_us_zipcode      = /^\d{5}$/;
export const valid_us_zipcode_9    = /^\d{5}(\d{4})?$/;
export const valid_us_zipcode_invalid      = /^(00000|99999)$/;
export const valid_us_zip4_invalid      = /^(0000|9999)$/;
export const valid_account_number_null  = /^null$/;
export const valid_card_security_code  = /^([0-9]{3,4})*$/;
export const valid_not_special_characters  = /^[0-9a-zA-z]*$/;
export const alphanumeric_with_spaces =  /^[A-Za-z0-9\s]*$/;
export const alpha_numeric_only =  /^[0-9A-Za-z]*$/;
export const valid_zipcode_five_digits =  /^[0-9]{5,5}$/;
export const valid_five_repeating_characters =  /(\d)\1{4}/;
export const valid_four_repeating_characters =  /(\d)\1{3}/;
export const valid_max_2_repeating_letters_invalid =  /([a-zA-Z])\1{2}/;
export const valid_length_exact_16  = /^.{16,16}$/;
export const not_less_than_one_dollar =  /^[1-9]+\d*\.?\d{0,2}$/;
export const valid_does_not_start_end_with_dash = /^[^-].*[^-]$/;
export const valid_length_minimum_2  = /^.{2,}$/;
export const valid_name =  /^[A-Za-z\.\-\'\s,]*$/;
export const valid_city_only_spaces_invalid = /^[ ]*$/;
export const valid_nick_name = /^[\dA-Za-z\!@$%\#^&\?\*\(\)_\-\=\+\{\}\[\]\,\.\s]{0,30}$/;
export const leading_or_trailing_spaces = /^[\s]+|[\s]+$/;


//To be refactored after prod release. Added for optional fields which can be of 0 length for disputes as the above validators do not accept 0 characters.
export const optional_valid_email_address   = /^(?!.*([.])\1{1})([\w\.\-\+\{\}\=\`\|\?]+)@(?![.-])([a-zA-Z\d.-]+)\.([a-zA-Z.][a-zA-Z]{1,6})?$/;
export const optional_valid_not_more_than_24 = /^(.{1,24})?$/;
export const optional_valid_acceptable = /^[a-zA-Z0-9-_\s\~\!\@\#\$\%\^\&\*\(\)\+\{\}\|\:\?\[\]\\\;\/\,\.]*$/;
export const optional_valid_not_more_than_17 = /^(.{1,17})?$/;
export const optional_valid_us_zipcode = /^(\d{5})?$/;
export const optional_valid_not_more_than_50 = /^(.{1,50})?$/;
export const optional_valid_not_more_than_25 = /^(.{1,25})?$/;
// Note: these validators could be used by both reactive and template forms
// However: since we are planning to only use reactive forms, the directives for 
//   template forms are not implemented, so only reactive forms are supported
// If you need directives, see the "forbidden-name.directive" example 
//   on https://angular.io/guide/form-validation

// validators
// note: instead of the pattern constants above, for custom cases the raw reg exp can be passed in
//added optional parameter to ignore null values if the field is optional
export function coreValidator(patternRegExp: RegExp, errorMessage: string, optional: boolean = false): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    let result = patternRegExp.test(control.value);
    // added below if condition to check null condition as well
    if (!optional) {
      if (control.value == null) {
        result = false;
      }
    } else {
      if (control.value === null) {
        result = true;
      }
    }
		//
    return result ? null : {'message': {value: errorMessage}};
  };
}

export function booleanValidator(errorMessage: string, optional: boolean): ValidatorFn {
	return (control: AbstractControl): { [key: string]: any } => {
	  let result = control.value;
	  // added below if condition to check null condition as well
	  console.log("optional==>"+optional);
	  console.log("control.value==>"+control.value);
	  return result ? null : {'message': {value: errorMessage}};
	};
  }


export function inverseCoreValidator(patternRegExp: RegExp, errorMessage: string): ValidatorFn {
	return (control: AbstractControl): {[key: string]: any} => {
		const result = !patternRegExp.test(control.value);
		return result ? null : {'message': {value: errorMessage}}; 
	};
}

export function isValidDate(patternRegExp: RegExp, errorMessage: string): ValidatorFn{
	var that = this;
	return (control: AbstractControl): {[key: string]: any} =>{
		const date: Date = new Date(Date.parse(control.value));
		const dateIsInvalid: boolean = isNaN(date.getTime());
		if(control.value !== "" && !dateIsInvalid){
			// Format day/month/year to two digits
			let formattedDate = ('0' + date.getDate()).slice(-2);
			let formattedMonth = ('0' + (date.getMonth() + 1)).slice(-2);
			let formattedYear = date.getFullYear().toString();
			// Combine and format date string
			let dateString = formattedMonth + '/' + formattedDate + '/' + formattedYear;			
			const result = patternRegExp.test(dateString);
			//if(result){control.value = dateString}
			return result ? null: {'message': {value: errorMessage}}
		}else if(dateIsInvalid && control.value !== undefined){
			return {'message': {value: errorMessage}}
		}else{
			return null;
		}
	}
}

export function minMaxDateValidator( minDate: Date, maxDate: Date, errorMessage: string): ValidatorFn{
	var that = this;
	return (control: AbstractControl): {[key: string]: any} =>{
		function isDateInRange(subject, minDate: Date, maxDate: Date): boolean {
			const date: Date = new Date(Date.parse(subject));
			const adjustedDate: Date = new Date(date.getTime() + date.getTimezoneOffset()*60000);
			const isInvalid: boolean = isNaN(adjustedDate.getTime());
			if (isInvalid){
				return true;
			}
			else if (!maxDate && !minDate) return true;
			else if (minDate && !maxDate) return adjustedDate.getTime() >= minDate.getTime();
			else if (maxDate && !minDate) return  adjustedDate.getTime() <= maxDate.getTime();
			else return adjustedDate.getTime() >= minDate.getTime()
						&& adjustedDate.getTime() <= maxDate.getTime();
		}

		return isDateInRange(control.value, minDate, maxDate) ? null: {'message': {value: errorMessage}}
	}
}

export function minMaxLengthValidator(answerMinLength: number, answerMaxLength: number, errorMessage: string): ValidatorFn {
	return (control: AbstractControl): {[key: string]: any} =>{
		let lengthRegex: RegExp;
		if (answerMinLength && answerMaxLength) {
			const maxLengthValidator = `^.\{${answerMinLength},${answerMaxLength}\}\$`;
			lengthRegex = new RegExp(maxLengthValidator);
		} else if (answerMinLength) {
			const maxLengthValidator = `^.\{${answerMinLength},\}\$`;
			lengthRegex = new RegExp(maxLengthValidator);
		} else if (answerMaxLength) {
			const maxLengthValidator = `^.\{0,${answerMaxLength}\}\$`;
			lengthRegex = new RegExp(maxLengthValidator);
		}
		const result = lengthRegex.test(control.value);
		return result ? null : {'message' : {value : errorMessage}}
	}
  }


export const formatToddmmyy = function(proposedDate: any){
	if(proposedDate !== null && proposedDate !== undefined && proposedDate !== ""){
	// Format day/month/year to two digits
	let formattedDate = ('0' + proposedDate.getDate()).slice(-2);
	let formattedMonth = ('0' + (proposedDate.getMonth() + 1)).slice(-2);
	let formattedYear = proposedDate.getFullYear().toString();
	// Combine and format date string
	let dateString = formattedMonth + '/' + formattedDate + '/' + formattedYear;	
	return dateString;
	}
}